function getCountryFlag(country) {
  return getRegionalIndicatorSymbol(country[0]) + getRegionalIndicatorSymbol(country[1]);
}
function getRegionalIndicatorSymbol(letter) {
  return String.fromCodePoint(127397 + letter.toUpperCase().charCodeAt(0));
}
export {
  getCountryFlag as default
};
//# sourceMappingURL=unicode.js.map
